package org.moxultimate.topwithmox.core.state

sealed class APIState<out T> {
    object Loading : APIState<Nothing>()
    data class Success<T>(val data: T) : APIState<T>()
    data class Error(val error: String, val statusCode: Int = 0) : APIState<Nothing>()
}
